import tw, { styled } from "twin.macro";

export const Slide = styled.img(({ theme }) => [
  tw`!h-screen	object-contain`,
  `font-family: ${theme.fontFamily.primary};`,
]);

